import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

declare const OneDrive: any;
@Injectable({
  providedIn: 'root'
})
export class OneDriveService {
  odOptions = {
   // clientId: "ab52f262-10ef-40cd-ac66-56db66565a91",
   clientId:  environment.oneDriveClientId,
    action: "download",
    multiSelect: false,
    accountSwitchEnabled: true,
    advanced: {
      queryParameters: "select=id,name,size,file,folder,photo,@microsoft.graph.downloadUrl",
      filter: "folder,.pdf,.doc,.docx"
    },
    success: (files: any) => {
      this.pickerCallback.successCallback(files)
    },
    cancel: () => {
      this.pickerCallback.cancelCallback()
    },
    error: (error: any) => {
      this.pickerCallback.errorCallback(error)
    }
  }
  pickerCallback: any;
  constructor() { }

  public open(data: any): void {
    this.pickerCallback = data;
    this.openOneDrive();
  }

  openOneDrive() {
    OneDrive.open(this.odOptions)
  }
}
